export default __webpack_public_path__ + "static/media/map.305981d9.png";